export default theme => ({
  dashboard_header_menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },

  dashboard_header_menuButton__hidden: {
    display: "none",
  },
});
